import { Pipe, PipeTransform } from '@angular/core';
import { Session } from '@univacity/shared/types';

@Pipe({
  name: 'session',
  standalone: false,
})
export class SessionPipe implements PipeTransform {
  transform(sessions: Session[], ...args: unknown[]): Session | null {
    sessions.sort(
      (a, b) => new Date(a.start).getTime() - new Date(b.start).getTime()
    );
    if (sessions.length > 0) return sessions[0];
    return null;
  }
}
